// src/pages/PrivacyPolicy.js
import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  max-width: 800px;
  margin: 0 auto;
  padding: 40px 20px;
`;

const Heading = styled.h1`
  font-size: 2rem;
  margin-bottom: 20px;
`;

const SubHeading = styled.h2`
  font-size: 1.5rem;
  margin-top: 30px;
  margin-bottom: 15px;
`;

const Paragraph = styled.p`
  margin-bottom: 15px;
  line-height: 1.6;
`;

const PrivacyPolicy = () => {
  return (
    <Container>
      <Heading>Privacy Policy</Heading>
      <Paragraph>Last Updated: March 14, 2025</Paragraph>
      
      <Paragraph>
        At ShowingBooker.com, we take your privacy seriously. This Privacy Policy explains how we collect, use, 
        disclose, and safeguard your information when you use our platform. Please read this policy carefully.
      </Paragraph>
      
      <SubHeading>1. Information We Collect</SubHeading>
      <Paragraph>
        <strong>1.1 Personal Information:</strong> When you register for an account, we collect your email address and 
        may generate a username for you. If you choose to provide additional information such as your name or payment 
        information, we will collect that as well.
      </Paragraph>
      <Paragraph>
        <strong>1.2 Usage Data:</strong> We collect information about how you interact with our platform, including 
        the images you generate, the prompts you use, your browsing activity, and your device information.
      </Paragraph>
      <Paragraph>
        <strong>1.3 Payment Information:</strong> When you make purchases or subscribe to our service, we collect 
        payment information. We do not store complete payment information on our servers.
      </Paragraph>
      
      <SubHeading>2. How We Use Your Information</SubHeading>
      <Paragraph>
        <strong>2.1</strong> To provide and maintain our service<br />
        <strong>2.2</strong> To process transactions and manage your account<br />
        <strong>2.3</strong> To improve our service and develop new features<br />
        <strong>2.4</strong> To communicate with you regarding service updates and promotional offers<br />
        <strong>2.5</strong> To monitor and analyze usage patterns and trends<br />
        <strong>2.6</strong> To detect, prevent, and address technical issues or violations of our Terms
      </Paragraph>
      
      <SubHeading>3. Data Sharing and Disclosure</SubHeading>
      <Paragraph>
        <strong>3.1 Service Providers:</strong> We may share your information with third-party vendors, service providers, 
        and contractors who need access to such information to perform services for us.
      </Paragraph>
      <Paragraph>
        <strong>3.2 Legal Requirements:</strong> We may disclose your information if required to do so by law or in 
        response to valid requests by public authorities.
      </Paragraph>
      <Paragraph>
        <strong>3.3 Business Transfers:</strong> If we are involved in a merger, acquisition, or sale of all or a 
        portion of our assets, your information may be transferred as part of that transaction.
      </Paragraph>
      
      <SubHeading>4. Data Security</SubHeading>
      <Paragraph>
        We implement appropriate technical and organizational measures to protect the security of your personal 
        information. However, no method of transmission over the Internet or electronic storage is 100% secure.
      </Paragraph>
      
      <SubHeading>5. User Rights</SubHeading>
      <Paragraph>
        Depending on your location, you may have certain rights regarding your personal information, including 
        the right to access, correct, or delete your personal information, or to object to or restrict certain 
        processing activities.
      </Paragraph>
      
      <SubHeading>6. Children's Privacy</SubHeading>
      <Paragraph>
        Our service is not intended for individuals under the age of 18. We do not knowingly collect personal 
        information from children under 18. If we become aware that we have collected personal information from 
        a child under 18, we will take steps to delete such information.
      </Paragraph>
      
      <SubHeading>7. Changes to This Privacy Policy</SubHeading>
      <Paragraph>
        We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new 
        Privacy Policy on this page and updating the "Last Updated" date.
      </Paragraph>
      
      <SubHeading>8. Contact Us</SubHeading>
      <Paragraph>
        If you have any questions about this Privacy Policy, please contact us at:
      </Paragraph>
      <Paragraph>
        ShowingBooker.com<br />
        Developed by David Levine Bramante with CodexDeus<br />
        Location: Los Angeles, CA<br />
        Email: hello@showingbooker.com<br />
        Phone: +1 (310) 906-5459<br />
        Website: <a href="https://www.codexdeus.com">www.CodexDeus.com</a><br />
      </Paragraph>
      
      <Paragraph>All rights reserved. Copyright © 2025 ShowingBooker.com | Developed by David Levine Bramante with CodexDeus.</Paragraph>
    </Container>
  );
};

export default PrivacyPolicy;